import { RouteProps } from 'react-router-dom'

import { PermissionRequirement, PermissionRoute } from '@cbgms/base/permissions/permissionsUtils'

import { useHasPermission } from './RequiredPermissions'

interface Props<Path extends string> extends RouteProps<Path> {
  permission: PermissionRequirement
}

/**
 * If the shop matches permission requirement it will render the route, otherwise it will redirect to a 404 page
 */
function ModulePermissionRoute<Path extends string = string>(props: Props<Path>) {
  const { permission } = props
  const [hasPermission] = useHasPermission(permission)

  return <PermissionRoute {...props} hasPermission={hasPermission} />
}

export default ModulePermissionRoute
